import { KeybeIconType } from '@/shared/infrastructure/enums/icons/KeybeIconType'
import KeybeIcon from '@/shared/infrastructure/ui/icons/KeybeIcon.vue'
import KBButton from '@/shared/infrastructure/ui/buttons/KBButton.vue'

export default {
  name: 'ButtonComissions',
  components: {
    KeybeIcon,
    KBButton
  },
  data () {
    return {
      KeybeIconType
    }
  },
  methods: {
    viewModal (): void{
      this.$emit('viewModal')
    }
  }
}
